import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';
import './CoachifyLanding.css';
import CoachifyLogo from '../../assets/logos/CoachifyFullVertLogo.png';

const CoachifyLanding = () => {
  const navigate = useNavigate();
  const [selectedGym, setSelectedGym] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // List of client gyms - will expand as more clients are added
  const clientGyms = [
    { id: 'unique-physique', name: 'Unique Physique', route: '/unique-physique' }
  ];

  const handleGymSelection = (gym) => {
    setSelectedGym(gym.name);
    setIsDropdownOpen(false);
    // Navigate to the selected gym's landing page
    navigate(gym.route);
  };

  return (
    <div className="coachify-landing">
      {/* Simple Header Navigation */}
      <header className="coachify-header">
        <nav className="coachify-nav">
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/features" className="nav-link">Features</Link>
          <Link to="/pricing" className="nav-link">Pricing</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </nav>
      </header>

      {/* Main Content */}
      <div className="coachify-main">
        {/* Coachify Brand Logo Centered */}
        <div className="coachify-brand">
          <img src={CoachifyLogo} alt="Coachify - Empowering Gyms, Transforming Lives" className="coachify-logo" />
        </div>

        {/* Gym Selector Dropdown */}
        <div className="gym-selector-container">
          <p className="selector-label">Select Your Gym</p>
          <div className="gym-dropdown">
            <button
              className={`dropdown-button ${isDropdownOpen ? 'open' : ''}`}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>{selectedGym || 'Choose a gym...'}</span>
              <FiChevronDown className={`dropdown-icon ${isDropdownOpen ? 'rotate' : ''}`} />
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu">
                {clientGyms.map((gym) => (
                  <div
                    key={gym.id}
                    className="dropdown-item"
                    onClick={() => handleGymSelection(gym)}
                  >
                    {gym.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachifyLanding;
